import React from 'react';
import { Header } from 'semantic-ui/semantic-ui-imports';
import { useTranslation } from 'react-i18next';
import ResetPasswordForm from '../../components/ResetPasswordForm';
import './index.scss';

const ResetPasswordPage = () => {
  const { t } = useTranslation();

  return (
    <div className="reset-password-page">
      <Header color="teal" className="reset-password-page__header">
        {t('resetPasswordPage.header')}
      </Header>
      <ResetPasswordForm />
    </div>
  );
};

export default ResetPasswordPage;
